import React from 'react';
import { CURRENT_YEAR } from 'shared/consts/time';
import { PATHS } from 'shared/consts/paths';
import { Container, Navigation, NavList, NavItem, Link, ExternalLink, Copyright } from './Footer.style';

const Footer: React.FC = () => {
    return (
        <Container>
            <Navigation>
                <NavList>
                    <NavItem>
                        <Copyright>© {CURRENT_YEAR} PhoneCheckr. All rights reserved.</Copyright>
                    </NavItem>
                    <NavItem>
                        <Link to={PATHS.TERMS_OF_USE}>Terms of Service</Link>
                    </NavItem>
                    <NavItem>
                        <Link to={PATHS.PRIVACY_POLICY}>Privacy Policy</Link>
                    </NavItem>
                    <NavItem>
                        <Link to={PATHS.PRICING}>Pricing</Link>
                    </NavItem>
                    <NavItem>
                        <Link to={PATHS.RESOURCES}>Resources</Link>
                    </NavItem>
                    <NavItem>
                        <Link to={PATHS.GLOSSARY}>Glossary</Link>
                    </NavItem>
                    <NavItem>
                        <Link to={PATHS.ABOUT}>About</Link>
                    </NavItem>
                    <NavItem>
                        <Link to={PATHS.CONTACT}>Contact</Link>
                    </NavItem>
                    <NavItem>
                        <ExternalLink href="/llms.txt">For AI agents</ExternalLink>
                    </NavItem>
                </NavList>
            </Navigation>
        </Container>
    );
};

export default Footer;
